import React, { useState } from 'react'
import ReservationSummary from './reservation-summary'

const CalendarHeader = props => {
  const [summaryOpened, setSummaryOpened] = useState(false)

  const headerButton = () => {
    if (props.sdAdminLevel) {
      return  (
        <button className='btn btn-success' onClick={props.onNewOpenGame}>
          New Event
        </button>
      )
    } else if (props.canCreate) {
      return (
        <button className='btn btn-success' onClick={props.onNewGame}>
          New Reservation
        </button>
      )
    }
  }

  return (
    <div className='row'>
      <div className='col-md-2'>
        {headerButton()}
      </div>
      <div className='col-md-9'>
        <ReservationSummary summary={props.summary} opened={summaryOpened} />
      </div>
      <div className='col-md-1 text-right reservation-category-summary__switcher'>
        <a href='#' className={'reservation-categories-switcher ' + (summaryOpened ? '' : 'collapsed')}>
          <br />
          <div className='open-games-eye' onClick={() => setSummaryOpened(!summaryOpened)}></div>
        </a>
      </div>
    </div>
  )
}

export default CalendarHeader
